import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

type SuperAppDeeplinkResponse = { url: string };

export const useBase64Deeplink = () => {
  /**
   * @description Since the API that creates short links does not accept characters,
   * such as `&?@` etc., we can't pass a url with search params in it, so we
   * decided to create a wrapper and pass the whole path as an encoded base64
   * string.
   *
   * @param path - vue-route path without base url and `avia` prefix
   */
  const createBase64Deeplink = async (path: string) => {
    if (!path.startsWith(`/`) || path.startsWith('/avia')) {
      throw new Error(
        'Deeplink must be a relative `route` path starting with `/` without `/avia` prefix',
      );
    }

    const url = `${window.location.origin}/avia/deeplink/base64/${btoa(path)}`;

    try {
      const { data } = await api.client.post<SuperAppDeeplinkResponse>(
        '/tourflow/api/tours/deeplinks',
        { url },
      );

      if (!data?.url) {
        throw new Error('Deeplink API returned no url');
      }
      return data.url;
    } catch (error) {
      sentryModel.captureException(
        sentryModel.getReadableError(
          'ERR_FAILED_TO_CREATE_BASE64_DEEPLINK',
          error as Error,
        ),
      );
      throw error;
    }
  };

  return {
    createBase64Deeplink,
  };
};
